import { Controller } from "@hotwired/stimulus"

// Manual "Apply credit" form. Mirrors charge_form, with one load-bearing
// difference: a credit LOWERS the balance, so the live "new balance" preview
// SUBTRACTS. (Reusing charge_form, which adds, would show the wrong projection.)
// Tap-to-fill presets set the amount + reason; credits carry no fee category.
export default class extends Controller {
  static targets = ["amount", "newBalance", "description", "chip"]
  static values = { currentCents: Number }

  connect() {
    this.preview()
  }

  preview() {
    const entered = this.#num(this.amountTarget)
    const newCents = this.currentCentsValue - Math.round(entered * 100)
    if (this.hasNewBalanceTarget) this.newBalanceTarget.textContent = this.#money(newCents / 100)
  }

  select(event) {
    const chip = event.currentTarget
    const { amount, description } = chip.dataset

    if (description && this.hasDescriptionTarget && !this.descriptionTarget.value) {
      this.descriptionTarget.value = description
    }
    if (amount) this.amountTarget.value = amount

    this.chipTargets.forEach((c) => this.#setSelected(c, c === chip))
    this.amountTarget.focus()
    this.preview()
  }

  #setSelected(chip, on) {
    chip.classList.toggle("ring-primary-300", on)
    chip.classList.toggle("bg-primary-50", on)
    chip.classList.toggle("text-primary-700", on)
    chip.classList.toggle("ring-secondary-200", !on)
    chip.setAttribute("aria-pressed", on ? "true" : "false")
  }

  #num(el) {
    const v = parseFloat(el.value)
    return Number.isNaN(v) ? 0 : v
  }

  #money(n) {
    return n.toLocaleString("en-US", { style: "currency", currency: "USD" })
  }
}
